import {
  api_send_support_message,
  api_get_my_support_messages,
  api_get_support_messages_cms,
  api_update_support_message
} from '../../../queries/supportMessages';

export const supportMessagesStoreActions = self => ({
  set(key, value) {
    self[key] = value;
  },

  async sendMessage(message) {
    self.set('sending', true);
    try {
      const res = await api_send_support_message(message, self.token);
      await self.loadMyMessages();
      return res?.data?.data;
    } finally {
      self.set('sending', false);
    }
  },

  async loadMyMessages() {
    try {
      const res = await api_get_my_support_messages(self.token);
      self.set('myMessages', res?.data?.data ?? []);
    } catch (error) {
      console.error('Failed to load my support messages', error);
    }
  },

  async loadMessages(params = {}) {
    self.set('loading', true);
    try {
      const res = await api_get_support_messages_cms(self.token, params);
      self.set('messages', res?.data?.data?.rows ?? []);
      self.set('count', res?.data?.data?.count ?? 0);
    } catch (error) {
      console.error('Failed to load support messages', error);
    } finally {
      self.set('loading', false);
    }
  },

  async markHandled(supportMessageId, status) {
    await api_update_support_message(supportMessageId, status, self.token);
    await self.loadMessages();
  }
});
